<script lang="ts">
    import { afterUpdate, onMount } from "svelte";
    import { GAME_APP_HOST } from "../Enum/EnvironmentVariable";
    import type { Game } from "../Phaser/Game/Game";
    import { errorScreenStore } from "../Stores/ErrorScreenStore";
    import { errorStore } from "../Stores/ErrorStore";
    import { gameSceneIsLoadedStore } from "../Stores/GameSceneStore";
    import { loginSceneVisibleStore } from "../Stores/LoginSceneStore";
    import { mapEditorModeStore } from "../Stores/MapEditorStore";
    import { enableCameraSceneVisibilityStore } from "../Stores/MediaStore";
    import { refreshPromptStore } from "../Stores/RefreshPromptStore";
    import {
        selectCharacterCustomizeSceneVisibleStore,
        selectCharacterSceneVisibleStore,
    } from "../Stores/SelectCharacterStore";
    import { selectCompanionSceneVisibleStore } from "../Stores/SelectCompanionStore";
    import EnableCameraScene from "./EnableCamera/EnableCameraScene.svelte";
    import LoginScene from "./Login/LoginScene.svelte";
    import MainLayout from "./MainLayout.svelte";
    import MapEditor from "./MapEditor/MapEditor.svelte";
    import RefreshPrompt from "./RefreshPrompt.svelte";
    import SelectCharacterScene from "./SelectCharacter/SelectCharacterScene.svelte";
    import SelectCompanionScene from "./SelectCompanion/SelectCompanionScene.svelte";
    import ErrorDialog from "./UI/ErrorDialog.svelte";
    import ErrorScreen from "./UI/ErrorScreen.svelte";

    export let game: Game;

    /**
     * When changing map from an exit on the current map, the Chat and the MainLayout are not really destroyed
     * due to an internal issue of Svelte, this is a work-around to force the component to be reloaded
     * https://github.com/sveltejs/svelte/issues/5268
     */
    let unique = {};
    afterUpdate(() => {
        unique = {};
    });

    onMount(() => {
        if (window) {
            if (
                window.origin !== `https://${GAME_APP_HOST}` &&
                window.origin !== "https://localhost:9042"
            ) {
                window.location.replace(`https://${GAME_APP_HOST}`);
            }
        }
    });
</script>

{#if $errorScreenStore !== undefined}
    <div>
        <ErrorScreen />
    </div>
{:else if $errorStore.length > 0}
    <div>
        <ErrorDialog />
    </div>
{:else if $loginSceneVisibleStore}
    <div class="scrollable">
        <LoginScene {game} />
    </div>
{:else if $selectCharacterSceneVisibleStore}
    <div>
        <SelectCharacterScene {game} />
    </div>
{:else if $selectCompanionSceneVisibleStore}
    <div>
        <SelectCompanionScene {game} />
    </div>
{:else if $enableCameraSceneVisibilityStore}
    <div class="scrollable">
        <EnableCameraScene {game} />
    </div>
{:else if $gameSceneIsLoadedStore && !$selectCharacterCustomizeSceneVisibleStore}
    {#key unique}
        <!-- <Chat /> // CQ MARKER DISABLE CHAT -->
        {#if $mapEditorModeStore}
            <MapEditor />
        {/if}
        {#if $refreshPromptStore}
            <RefreshPrompt />
        {/if}
        <MainLayout />
    {/key}
{/if}
